import script from "./captchaInput.vue?vue&type=script&setup=true&lang=js"
export * from "./captchaInput.vue?vue&type=script&setup=true&lang=js"

import "./captchaInput.vue?vue&type=style&index=0&id=4a9cedf9&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"captchaInput.vue"]])

export default __exports__